import {
  vBoolean,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
} from '../validation/index.ts'
import { quoteReasonsSchema } from './quote-selection-reason.ts'

export const bookRateSchema = vObject({
  schedulePickup: vBoolean(),
  quoteReason: vOptional(quoteReasonsSchema),
})
export type BookRateDTO = vOutput<typeof bookRateSchema>

export const retenderReasons = ['carrier-withdraw', 'shipper-retract'] as const
export type RetenderReason = (typeof retenderReasons)[number]

export const retenderLoadSchema = vObject({
  quoteId: vObjectId(),
  reason: vOptional(vPicklist(retenderReasons)),
})
export type RetenderLoadDto = vOutput<typeof retenderLoadSchema>
